var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('popup', {
    attrs: {
      "opened": _vm.dataToShow
    },
    on: {
      "close": _vm.closePopup
    }
  }, [_c('div', {
    staticClass: "mx-5 xl:mx-44 2xl:mx-40 my-8 w-auto h-auto flex flex-col items-center space-y-10"
  }, [_c('h3', [_vm._v("\n      Choisir le compte à se connecter sur la structure " + _vm._s(_vm.structure.name) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col space-y-10 justify-center items-center w-full h-full"
  }, [_vm.accounts.length === 0 ? _c('p', {
    staticClass: "animate-pulse"
  }, [_vm._v("\n        Chargement des utilisateurs de la structure " + _vm._s(_vm.structure.name) + "...\n      ")]) : _vm._e(), _vm._v(" "), _vm.accounts.length > 0 ? _c('div', {
    staticClass: "flex flex-col space-y-10 items-center w-full"
  }, [_c('div', {
    staticClass: "w-full"
  }, [_c('search-bar', {
    attrs: {
      "name": "searchAccount",
      "libelle": "",
      "value": _vm.search,
      "placeholder": "Rechercher un compte",
      "big": false,
      "inherits": false,
      "has-border": false
    },
    on: {
      "input": function (newValue) {
        _vm.search = newValue;
      }
    }
  })], 1), _vm._v(" "), _vm.admins.length > 0 ? _c('div', {
    staticClass: "flex flex-col space-y-5 items-center w-full"
  }, [_c('p', {
    staticClass: "text-indigo-600"
  }, [_vm._v("\n            Administrateurs\n          ")]), _vm._v(" "), _c('list-grid', {
    staticClass: "w-full",
    attrs: {
      "list-items": _vm.admins,
      "is-listdisplayed": _vm.admins.length > 0,
      "height-line": "h-16"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_c('div', {
          staticClass: "col-span-5 pl-5"
        }, [_vm._v("\n                Nom\n              ")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-5"
        }, [_vm._v("\n                Role\n              ")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-2"
        }, [_vm._v("\n                Connexion\n              ")])];
      },
      proxy: true
    }, {
      key: "accordionDescription",
      fn: function (_ref) {
        var item = _ref.item,
          num = _ref.num;
        return [_c('div', {
          staticClass: "col-span-5 pl-5"
        }, [_vm._v("\n                " + _vm._s(item.firstname) + " " + _vm._s(item.lastname) + "\n              ")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-5"
        }, [_vm._v("\n                " + _vm._s(item.role.name) + "\n              ")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-2"
        }, [_c('circle-button', {
          attrs: {
            "icon": "monitor",
            "label": "Accéder à l'interface Neopass de la structure"
          },
          on: {
            "buttonClick": function ($event) {
              return _vm.connectToAccount(item);
            }
          }
        })], 1)];
      }
    }], null, false, 2695388088)
  })], 1) : _vm._e(), _vm._v(" "), _vm.referents.length > 0 ? _c('div', {
    staticClass: "flex flex-col space-y-5 items-center w-full"
  }, [_c('p', {
    staticClass: "text-indigo-600"
  }, [_vm._v("\n            Référents\n          ")]), _vm._v(" "), _c('list-grid', {
    staticClass: "w-full",
    attrs: {
      "list-items": _vm.referents,
      "is-listdisplayed": _vm.referents.length > 0,
      "height-line": "h-16"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_c('div', {
          staticClass: "col-span-5 pl-5"
        }, [_vm._v("\n                Nom\n              ")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-5"
        }, [_vm._v("\n                Role\n              ")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-2"
        }, [_vm._v("\n                Connexion\n              ")])];
      },
      proxy: true
    }, {
      key: "accordionDescription",
      fn: function (_ref2) {
        var item = _ref2.item,
          num = _ref2.num;
        return [_c('div', {
          staticClass: "col-span-5 pl-5"
        }, [_vm._v("\n                " + _vm._s(item.firstname) + " " + _vm._s(item.lastname) + "\n              ")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-5"
        }, [_vm._v("\n                " + _vm._s(item.role.name) + "\n              ")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-2"
        }, [_c('circle-button', {
          attrs: {
            "icon": "monitor",
            "label": "Accéder à l'interface Neopass de la structure"
          },
          on: {
            "buttonClick": function ($event) {
              return _vm.connectToAccount(item);
            }
          }
        })], 1)];
      }
    }], null, false, 2695388088)
  })], 1) : _vm._e(), _vm._v(" "), _vm.beneficiaries.length > 0 ? _c('div', {
    staticClass: "flex flex-col space-y-5 items-center w-full"
  }, [_c('p', {
    staticClass: "text-indigo-600"
  }, [_vm._v("\n            Bénéficiaires\n          ")]), _vm._v(" "), _c('list-grid', {
    staticClass: "w-full",
    attrs: {
      "list-items": _vm.beneficiaries,
      "is-listdisplayed": _vm.beneficiaries.length > 0,
      "height-line": "h-16"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_c('div', {
          staticClass: "col-span-5 pl-5"
        }, [_vm._v("\n                Nom\n              ")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-5"
        }, [_vm._v("\n                Role\n              ")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-2"
        }, [_vm._v("\n                Connexion\n              ")])];
      },
      proxy: true
    }, {
      key: "accordionDescription",
      fn: function (_ref3) {
        var item = _ref3.item,
          num = _ref3.num;
        return [_c('div', {
          staticClass: "col-span-5 pl-5"
        }, [_vm._v("\n                " + _vm._s(item.firstname) + " " + _vm._s(item.lastname) + "\n              ")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-5"
        }, [_vm._v("\n                " + _vm._s(item.role.name) + "\n              ")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-2"
        }, [_c('circle-button', {
          attrs: {
            "icon": "monitor",
            "label": "Accéder à l'interface Neopass de la structure"
          },
          on: {
            "buttonClick": function ($event) {
              return _vm.connectToAccount(item);
            }
          }
        })], 1)];
      }
    }], null, false, 2695388088)
  })], 1) : _vm._e()]) : _vm._e()])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }